module.exports = __webpack_public_path__ + "static/img/icon3.eb2ab5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/all/icon3.png
// module id = rg6b
// module chunks = 0